import { apiGet } from '../../utilities/apiClient';
import { getSessionIds } from './_sessionIds';
import { SET_BLOCKS, SET_BLOCKS_LOADING, SET_SEGMENTS, SET_SEGMENTS_LOADING } from '../constants';

export const fetchBlocks = () => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  dispatch({ type: SET_BLOCKS_LOADING, payload: true });
  try {
    const res = await apiGet(`/blocks/get-all/${accountId}/${cognitoId}`);
    dispatch({ type: SET_BLOCKS, payload: res?.payload || [] });
    return res;
  } catch (err: any) {
    dispatch({ type: SET_BLOCKS, payload: [] });
    return { success: false, message: err?.message };
  } finally {
    dispatch({ type: SET_BLOCKS_LOADING, payload: false });
  }
};

export const fetchSegments = (projectId: number | string) => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  dispatch({ type: SET_SEGMENTS_LOADING, payload: true });
  try {
    const res = await apiGet(`/segments/get-all/${projectId}/${accountId}/${cognitoId}`);
    dispatch({ type: SET_SEGMENTS, payload: { projectId: String(projectId), segments: res?.payload || [] } });
    return res;
  } catch (err: any) {
    dispatch({ type: SET_SEGMENTS, payload: { projectId: String(projectId), segments: [] } });
    return { success: false, message: err?.message };
  } finally {
    dispatch({ type: SET_SEGMENTS_LOADING, payload: false });
  }
};
